import type { AuthState } from '../slices/authSlice.ts';
import type { AppState } from '../slices/appSlice.ts';
import type { ThemeState } from '../slices/themeSlice.ts';

export interface CommonState { auth: AuthState; app: AppState; theme: ThemeState }

export const selectAuth = (state: Pick<CommonState, 'auth'>) => state.auth;
export const selectUser = (state: Pick<CommonState, 'auth'>) => state.auth.user;
export const selectRoles = (state: Pick<CommonState, 'auth'>) => state.auth.roles;
export const selectAccessToken = (state: Pick<CommonState, 'auth'>) => state.auth.accessToken;
export const selectAuthInitialized = (state: Pick<CommonState, 'auth'>) => state.auth.isInitialized;
export const selectApp = (state: Pick<CommonState, 'app'>) => state.app;
export const selectSelectedPsl = (state: Pick<CommonState, 'app'>) => state.app.selectedPsl;
export const selectThemeMode = (state: Pick<CommonState, 'theme'>) => state.theme.mode;